import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import FloatingLabel from "react-bootstrap/FloatingLabel";

import Footer from "../components/Footer";
import Navbar from "../components/SpectraNavbar";
import ForgotPasswordModal from "../components/ui/ForgotPasswordModal";

import { useUserContext } from "../contexts";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/Login.css";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [validated, setValidated] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [alertFromRedirect, setAlertFromRedirect] = useState(null);

  const { login } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  // Check for alert passed via location state
  useEffect(() => {
    if (location.state?.alert) {
      setAlertFromRedirect(location.state.alert);
      // Clear the state to prevent showing alert on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      // setErrorMessage("Please fill out all required fields.");
      return;
    } else {
      try {
        await login(email, password);
        console.log("Login successful");
        navigate("/");
      } catch (error) {
        console.error("Login failed:", error);
        setErrorMessage(error);
      }
    }
  };

  const handleShowPassword = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div
      id='main-wrapper'
      className='d-flex flex-column container-fluid bg-light min-vh-100'
    >
      <Navbar />

      <div
        className='d-flex justify-content-center align-items-center container-fluid flex-grow-1 h-100'
        style={{ paddingTop: "79px" }}
      >
        <div id='login-form' className='col-lg-8 col-12  bg-white p-5 border'>
          <header className='mb-4 text-center'>
            <h1 className='mb-1'>Welcome!</h1>
            <p className='text-muted fs-5'>Sign in to start testing</p>
          </header>
          <Form noValidate className='my-3' onSubmit={onSubmit}>
            {alertFromRedirect && (
              <Alert
                variant={alertFromRedirect.variant}
                dismissible
                onClose={() => setAlertFromRedirect(null)}
              >
                <i className='bi bi-exclamation-circle me-2'></i>
                {alertFromRedirect.message}
              </Alert>
            )}
            {errorMessage && (
              <Alert variant='danger'>
                <i className='bi bi-exclamation-circle me-2'></i>
                {errorMessage}
              </Alert>
            )}
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <FloatingLabel label='Username or Email Address'>
                <Form.Control
                  className='login-input'
                  onChange={(e) => setEmail(e.target.value)}
                  type='text'
                  autoComplete='username'
                  placeholder='Username or Email Address'
                  required
                  isInvalid={validated && email === ""}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide a username or email address.
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>

            <Form.Group className='mb-1' controlId='formBasicPassword'>
              <FloatingLabel label='Password'>
                <Form.Control
                  type={isVisible ? "text" : "password"}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete='current-password'
                  placeholder='Password'
                  required
                  isInvalid={validated && password === ""}
                />
                <Form.Control.Feedback type='invalid'>
                  Please provide a password.
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>

            <div className='d-flex justify-content-between align-items-center'>
              <Form.Check
                type='checkbox'
                label='Show Password'
                id='show-password-checkbox'
                onChange={handleShowPassword}
                className='ms-2 w-50'
              />

              <button
                type='button'
                onClick={() => setShowForgotPasswordModal(true)}
                className='btn btn-link float-end p-0'
              >
                Forgot Password?
              </button>
            </div>

            <div className='d-grid'>
              <Button variant='primary' className='mt-4' type='submit'>
                Sign in
              </Button>
            </div>
          </Form>
          <ForgotPasswordModal
            show={showForgotPasswordModal}
            handleClose={() => setShowForgotPasswordModal(false)}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
